import React, { useMemo } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import {
  clearCanaryOverrides,
  convertFlagsObjectToConfig,
  getCanaryOverrides,
  setCanaryOverrides,
} from '@bill/canary.browser-utils'
import { CanaryProvider, CanaryStoreEntry } from '@bill/canary.react'
import { rum } from '@divvy-web/utils.log'

import canaryConfig from './canaryConfig'

export const SputnikCanaryProvider = ({ children }: React.PropsWithChildren) => {
  const launchDarklyFlags = useFlags()
  const flags: CanaryStoreEntry[] = convertFlagsObjectToConfig(launchDarklyFlags)

  const config: CanaryStoreEntry[] = useMemo(() => {
    const otherEntries = flags.filter(
      ({ name }) => !canaryConfig.some(({ name: overrideName }) => name === overrideName),
    )
    const definedEntries = flags
      .filter(({ name }) => canaryConfig.some(({ name: overrideName }) => name === overrideName))
      .map((ldFlag) => {
        const canaryConfigEntry = canaryConfig.find(({ name }) => name === ldFlag.name)
        if (canaryConfigEntry) {
          return {
            ...canaryConfigEntry,
            value: ldFlag.value,
          }
        }

        return ldFlag
      })
    const nonLDEntries = canaryConfig.filter(({ name }) => !definedEntries.some(({ name: ldName }) => ldName === name))

    return [...definedEntries, ...otherEntries, ...nonLDEntries]
  }, [flags])

  return (
    <CanaryProvider
      canaryHashName='#canary-ui'
      config={config}
      globalName='canary-ui'
      overrides={getCanaryOverrides('canary')}
      onEvaluateFlag={(key, value) => {
        rum && rum.addFeatureFlagEvaluation(key, value)
      }}
      // TODO: update types for setCanaryOverrides to match what is expected on
      //       onFlagChange of CanaryProvider
      //@ts-expect-error
      onFlagChange={setCanaryOverrides('canary')}
      onResetOverrides={clearCanaryOverrides('canary')}
    >
      {children}
    </CanaryProvider>
  )
}
